export default __webpack_public_path__ + "static/media/Iconography_Caesarzkn.84dabcad.svg";